import * as MuiIcons from '@mui/icons-material';

export interface DashboardModuleMeta {
  key: string;
  label: string;
  path: string;
  icon: string;
  color: string;
  group: string;
}

const MODULE_META: Record<string, Omit<DashboardModuleMeta, 'key' | 'label'>> = {
  clients: { path: '/clients', icon: 'Business', color: '#6366f1', group: 'Operations' },
  trips: { path: '/trips', icon: 'Route', color: '#22c55e', group: 'Operations' },
  documents: { path: '/vehicles/documents', icon: 'Folder', color: '#3b82f6', group: 'Operations' },
  branches: { path: '/branches', icon: 'AccountTree', color: '#64748b', group: 'Fleet' },
  drivers: { path: '/drivers', icon: 'Person', color: '#4ade80', group: 'Fleet' },
  helpers: { path: '/helpers', icon: 'Groups', color: '#10b981', group: 'Fleet' },
  vehicles: { path: '/vehicles', icon: 'DirectionsCar', color: '#16a34a', group: 'Fleet' },
  fuel: { path: '/fuel', icon: 'LocalGasStation', color: '#f59e0b', group: 'Fleet' },
  maintenance: { path: '/maintenance', icon: 'Build', color: '#d97706', group: 'Fleet' },
  invoices: { path: '/invoices', icon: 'Receipt', color: '#0ea5e9', group: 'Finance' },
  bilty: { path: '/bilty', icon: 'Payments', color: '#0284c7', group: 'Finance' },
};

export function getModuleMeta(key: string, label?: string, type?: string): DashboardModuleMeta {
  const base = MODULE_META[key];
  if (base) return { key, label: label || key, ...base };
  return {
    key,
    label: label || key,
    path: type === 'custom' ? `/crm/${key}` : `/${key}`,
    icon: 'Extension',
    color: '#22c55e',
    group: 'CRM',
  };
}

export function getModuleIcon(iconName: string) {
  const Icon = (MuiIcons as Record<string, React.ComponentType<{ sx?: object }>>)[iconName] || MuiIcons.Folder;
  return Icon;
}

export const DATE_PRESETS = [
  { label: 'Today', days: 0 },
  { label: '7 Days', days: 7 },
  { label: '30 Days', days: 30 },
  { label: '90 Days', days: 90 },
  { label: 'All Time', days: -1 },
] as const;

export function getDateRangeFromPreset(days: number): { fromDate: string; toDate: string } {
  if (days < 0) return { fromDate: '', toDate: '' };
  const to = new Date();
  const from = new Date();
  if (days === 0) {
    // today only
  } else {
    from.setDate(from.getDate() - days);
  }
  return {
    fromDate: from.toISOString().slice(0, 10),
    toDate: to.toISOString().slice(0, 10),
  };
}

export const STATUS_OPTIONS = [
  { value: 'all', label: 'All Status' },
  { value: 'active', label: 'Active' },
  { value: 'pending', label: 'Pending' },
  { value: 'completed', label: 'Completed' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'paid', label: 'Paid' },
];

export const CHART_COLORS_FALLBACK = ['#22c55e', '#16a34a', '#4ade80', '#86efac', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6'];

/** Chart palette derived from tenant brand (Recharts needs hex, not CSS vars). */
export function getChartColors(primary: string, primaryDark: string, primaryLight: string): string[] {
  return [primary, primaryDark, primaryLight, `${primaryLight}99`, '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6'];
}

/** @deprecated Use getChartColors(brand.primary, brand.primaryDark, brand.primaryLight) */
export const CHART_COLORS = CHART_COLORS_FALLBACK;
